/*
  industrialkonzept Next: the variant picker on product pages (loaded from snippets/ik-product-extras.liquid).
  The theme's own dropdown stays (it switches pictures, price and cart); this adds to each choice how soon
  it ships, taken from the theme's own stock line for that variant, shortened:
  "Ready to ship" (solid dot), "Ready to ship · few left", "2–4 weeks" (hollow dot) or "Sold out".
  With several options (size and colour) each choice shows the status of the variant it would lead to,
  and its price: the list itself (snippets/product-form-component-variant-picker.liquid) can only give
  the range over all colours ("€368,90 – €407,90"), here it becomes the price of that exact variant.
  Every choice that can be bought in some variant stays in the list, also a colour the chosen size does
  not come in; picking it moves the other options to the closest variant that has it.
  The option's name loses its colon; names that say nothing ("Option") are hidden.
  Looks: assets/ik-shop.css ("Variant picker"). Nothing to keep up: new variants and new stock just show.
*/
(() => {
  const pickers = () => [...document.querySelectorAll('.product-variant-picker-block')];
  if (!pickers().length) return;
  const T = (k, v) => (window.ikT ? window.ikT(k, v) : k);
  const S = { ready: T('variant.ready'), readyFew: T('variant.ready_few'), sold: T('variant.sold') };

  // the theme writes one stock line per variant: "Golden: • Available for order: … 2-4 weeks"
  const statusOf = (id) => {
    const el = document.querySelector('.product-inventory-status-block [x-show="currentVariantId === ' + id + '"]');
    if (!el) return null;
    // made to order: the theme puts the delivery time in short form on the line ("2–4 weeks")
    const lead = el.querySelector('[data-ikn-lead]');
    if (lead && lead.dataset.iknLead) return { k: 'order', text: lead.dataset.iknLead };
    const raw = (el.querySelector('.ikn-avail') || el).textContent.replace(/\s+/g, ' ').trim();
    const t = raw.slice(raw.indexOf('•') + 1).trim() || raw;
    if (/out of stock|sold out|ausverkauft|nicht (mehr )?verfügbar|nicht vorrätig|nicht auf lager/i.test(t)) return { k: 'sold', text: S.sold };
    if (/low stock|few|wenige|nur noch|begrenzt|niedrig/i.test(t)) return { k: 'ready', text: S.readyFew };
    // made to order first: its German line also starts with "Verfügbar"
    const m = t.match(/(\d+\s*[-–]\s*\d+|\d+)\s*(weeks?|wochen|days?|werktage|tage|months?|monate)/i);
    if (m) return { k: 'order', text: m[1].replace(/\s*[-–]\s*/, '–') + ' ' + m[2] };
    if (/ready to ship|in stock|sofort|auf lager|vorrätig|^verfügbar$|^available$/i.test(t)) return { k: 'ready', text: S.ready };
    return { k: 'order', text: t.length > 40 ? '' : t };
  };

  let variants = [];
  const base = location.pathname.replace(/\/$/, '');
  fetch(base + '.js', { headers: { Accept: 'application/json' } })
    .then((r) => (r.ok ? r.json() : null))
    .then((p) => {
      if (!p) return;
      variants = p.variants || [];
      pickers().forEach((fs) => {
        fs.querySelectorAll('[role="option"][data-single-option-selector]').forEach(unhide);
        decorate(fs);
      });
    })
    .catch(() => {});

  // the variant a choice leads to: the exact combination if it can be bought, otherwise the variant
  // with that choice that keeps most of the other options, one that can be bought first
  const leadsTo = (now, pos, value) => {
    const want = now.slice();
    want[pos] = value;
    const exact = variants.find((x) => (x.options || []).every((o, i) => want[i] == null || o === want[i]));
    if (exact && exact.available) return exact;
    const score = (x) => (x.available ? 100 : 0) + (x.options || []).filter((o, i) => i !== pos && o === now[i]).length;
    const best = variants.filter((x) => (x.options || [])[pos] === value).sort((a, b) => score(b) - score(a))[0];
    return best || exact || null;
  };

  // The theme hides a choice that does not fit the other options ("Hide unavailable variants") or whose
  // variant there is sold out and not for sale ("Hide sold out variants"). A colour the chosen size does
  // not come in seemed missing. Such a choice comes back when some variant with it can be bought;
  // choices that cannot be bought in any variant stay hidden.
  const sellable = (pos, value) => variants.some((x) => x.available && (x.options || [])[pos] === value);
  const unhide = (opt) => {
    if (!variants.length || !(opt.classList.contains('unavailable') || opt.classList.contains('sold-out'))) return;
    if (!sellable(Number(opt.dataset.position) - 1, opt.value)) return;
    opt.classList.remove('unavailable', 'sold-out');
    opt.disabled = false;
  };
  const watch = new MutationObserver((list) => list.forEach((m) => m.target.matches('[data-single-option-selector]') && unhide(m.target)));
  pickers().forEach((fs) => watch.observe(fs, { subtree: true, attributes: true, attributeFilter: ['class'] }));

  // what is chosen right now in each option: the selected choice's value (not the button text,
  // which the cm/inch switch in ik-tools.js may have rewritten)
  const chosen = () =>
    pickers().map((fs) => {
      const sel = fs.querySelector('[role="option"][aria-selected="true"]');
      if (sel) return sel.value;
      const b = fs.querySelector('button[x-ref="button"] > div');
      return b ? b.textContent.trim() : null;
    });

  const decorate = (fs) => {
    const now = chosen();
    fs.querySelectorAll('[role="option"][data-position]').forEach((opt) => {
      const pos = Number(opt.getAttribute('data-position')) - 1;
      const v = leadsTo(now, pos, opt.value);
      let s = v ? statusOf(v.id) : null;
      if (v && !v.available) s = { k: 'sold', text: S.sold };
      const price = opt.querySelector('span.whitespace-nowrap');
      if (price && v && window.ikMoney) price.textContent = window.ikMoney(v.price);
      // the theme loads 64 px pictures for a 48 px square: sharp only on plain screens
      const pic = opt.querySelector('img');
      if (pic && /[?&]width=64\b/.test(pic.getAttribute('src') || '')) pic.src = pic.getAttribute('src').replace(/([?&]width=)64\b/, '$1144');
      const name = opt.querySelector('span.flex-1') || opt;
      let tag = name.querySelector('.ikv-status');
      if (!s || !s.text) {
        if (tag) tag.remove();
        return;
      }
      if (!tag) {
        tag = document.createElement('span');
        name.appendChild(tag);
      }
      tag.className = 'ikv-status is-' + s.k;
      tag.textContent = s.text;
    });
    // the option's name without the colon; a name that says nothing ("Option", "Title") is left out
    const label = fs.querySelector(':scope > label');
    if (label && !label.dataset.ikv) {
      label.dataset.ikv = '1';
      const t = label.textContent.replace(/\s+/g, ' ').replace(/:\s*$/, '').trim();
      if (/^(option|options|title|titel|variante?|variant|default)$/i.test(t)) label.style.display = 'none'; // the theme's class "block" would win over hidden
      else label.textContent = t;
    }
    fs.classList.add('ikv');
  };

  // a choice the other options do not fit: all options move at once to the closest variant that has it,
  // before the theme's own click handler sets just this one (it then finds it already set). Set one by
  // one, the theme would meet a combination that does not exist in between.
  document.addEventListener(
    'click',
    (e) => {
      const opt = e.target.closest('.product-variant-picker-block [role="option"][data-single-option-selector]');
      if (!opt || !variants.length || !window.Alpine) return;
      const data = window.Alpine.$data(opt);
      if (!data || data.option1 === undefined) return;
      const count = (variants[0].options || []).length;
      const now = [1, 2, 3].slice(0, count).map((i) => data['option' + i]);
      const pos = Number(opt.dataset.position) - 1;
      const to = leadsTo(now, pos, opt.value);
      if (!to || (to.options || []).every((o, i) => i === pos || o === now[i])) return;
      (to.options || []).forEach((o, i) => {
        if (data['option' + (i + 1)] !== o) data['option' + (i + 1)] = o;
      });
    },
    true
  );

  // after every choice the other options lead to other variants: refresh when a dropdown opens
  document.addEventListener('click', (e) => {
    const fs = e.target.closest('.product-variant-picker-block');
    if (fs && variants.length) requestAnimationFrame(() => decorate(fs));
  });
})();
